export class ObjectUtils {
    static isEqualObjectStruct<T> (current: Record<string, T>, expected: Record<string, T>): boolean {
        if (Object.keys(current).length !== Object.keys(expected).length) {
            return false
        }
        for (const key in expected) {
            if (!Object.prototype.hasOwnProperty.call(expected, key) ||
                    !Object.prototype.hasOwnProperty.call(current, key)) {
                return false
            }
            if (typeof current[key] !== typeof expected[key]) {
                return false
            }
            if (typeof current[key] === 'object') {
                const currentSubStruct = current[key] as unknown as Record<string, T>
                const expectedSubStruct = expected[key] as unknown as Record<string, T>
                if (!ObjectUtils.isEqualObjectStruct(currentSubStruct, expectedSubStruct)) {
                    return false
                }
            }
        }
        return true
    }

    static isEmpty (neededData: object | null | undefined): boolean {
        return !neededData || Object.keys(neededData).length === 0
    }

    static findContentReferenceAndKey<T> (
        baseContent: Record<string, T>, fieldPath: string
    ): [Record<string, T> | undefined, string | undefined] {
        if (!fieldPath) {
            return [undefined, undefined]
        }

        let currentReference = baseContent
        const pathKeys = fieldPath.split('.')
        const depthOfPath = pathKeys.length - 1

        for (const index in pathKeys) {
            const key = pathKeys[index]
            if (typeof currentReference !== 'object' || !currentReference ||
                    !Object.prototype.hasOwnProperty.call(currentReference, key)) {
                return [undefined, undefined]
            }
            if (parseInt(index) !== depthOfPath) {
                currentReference = currentReference[key] as unknown as Record<string, T>
            } else {
                break
            }
        }

        return [currentReference, pathKeys[depthOfPath]]
    }
}
